<template>
  <div>
    <HeaderComponentPackage
      :apiUrl="getApiUrl"
      :themeColor="getThemeColor"
      :routes="menu"
      :authenticated="getAuthenticated"
      :companyObj="getUserSchool"
      logoRoute="/auth/get-logos-for-given-school"
    ></HeaderComponentPackage>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import HeaderComponentPackage from "baron-vue-header-frontend";

export default {
  components: { HeaderComponentPackage },

  computed: {
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
  },
  updated() {
    this.$store.commit("setVuetifyObject", this.$vuetify);
  },
  mounted() {
    this.$store.commit("setVuetifyObject", this.$vuetify);

    this.$store.commit("setLoader", true);
    if (
      localStorage.getItem("token") != null &&
      localStorage.getItem("authenticated") != null
    ) {
      this.$store.commit("setAccessToken", localStorage.getItem("token"));
      this.$store.commit("setAuthenticated", true);
    }
    let domain = "";

    domain = window.location.hostname;

    axios.postData("/get-school-website-banner", { domain }).then((pics) => {
      this.$store.commit("setFrontPageImages", pics);
      axios.postData("/get-school-with-domain", { domain }).then((data) => {
        this.$store.commit("setUserSchool", data.school);
        this.$store.commit("setThemeColor", data.school.primary_bg_color);
        this.$store.commit("setSecondaryColor", data.school.secondary_bg_color);
        this.$store.commit("setAppName", data.school.schname);
        this.$store.commit("setSiteArticles", data.posts);
        this.$store.commit("setSiteStats", data.stats);

        localStorage.setItem("themeColor", data.school.primary_bg_color);
        localStorage.setItem("secondaryColor", data.school.secondary_bg_color);
        localStorage.setItem("appName", data.school.schname);
        localStorage.setItem("userSchool", JSON.stringify(data.school));

        this.$store.commit("setLoader", false);
      });
    });
  },
  data() {
    return {
      menu: [
        {
          icon: "mdi-home",
          title: "Home",
          description: "",
          color: "deep-orange darken-4",
          route: "school-website",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },

        {
          icon: "apps",
          title: "Switchboard",
          description: "",
          color: "deep-orange darken-4",
          route: "switchboard",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },
        {
          icon: "mdi-play-box-multiple",
          title: "Gallery",
          description: "",
          color: "deep-orange darken-4",
          route: "images-gallery",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },
        {
          icon: "assignment_ind",
          title: "Sign In",
          description: "",
          color: "deep-orange darken-4",
          route: "login",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },
        {
          icon: "person_add",
          title: "Create Account",
          description: "",
          color: "deep-orange darken-4",
          route: "register",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },
      ],
    };
  },
};
</script>
